import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import HourglassTop from "@mui/icons-material/HourglassTop";
import RefreshOutlined from "@mui/icons-material/RefreshOutlined";
import { useTranslation } from "react-i18next";

export function CalibrationStartedDialog({
  open,
  onAcknowledge,
}: {
  open: boolean;
  onAcknowledge: () => void;
}) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      aria-labelledby="calibration-started-title"
      slotProps={{
        paper: {
          sx: {
            borderRadius: 3,
            boxShadow: 24,
          },
        },
      }}
    >
      <DialogTitle
        id="calibration-started-title"
        sx={{
          pb: 2,
          borderBottom: 1,
          borderColor: "divider",
          fontSize: "1.25rem",
          fontWeight: 700,
        }}
      >
        {t("header.calibrate.dialog.started.title")}
      </DialogTitle>

      <DialogContent sx={{ pt: "24px !important" }}>
        <Typography variant="body1" mb={2}>
          {t("text.calibrate.dialog.started.explanation")}
        </Typography>

        <Stack
          spacing={2}
          sx={{
            p: 2,
            bgcolor: "background.default",
            borderRadius: 2,
            border: "1px solid",
            borderColor: "divider",
          }}
        >
          <Stack direction="row" gap={1.5} alignItems="flex-start">
            <HourglassTop sx={{ color: "text.secondary" }} />
            <Typography variant="body2">
              {t("text.calibrate.dialog.started.duration")}
            </Typography>
          </Stack>

          <Stack direction="row" gap={1.5} alignItems="flex-start">
            <RefreshOutlined sx={{ color: "text.secondary" }} />
            <Typography variant="body2">
              {t("text.calibrate.dialog.started.updates")}
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>

      <DialogActions
        sx={{
          p: 3,
          pt: 1,
          borderTop: 1,
          borderColor: "divider",
          bgcolor: "background.default",
        }}
      >
        <Button
          onClick={onAcknowledge}
          variant="contained"
          fullWidth
          sx={{ fontWeight: "bold", py: 1.25 }}
        >
          {t("button.close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
